import React, { useState } from 'react';
import axios from 'axios';
import Header from '../components/Header';
import Link from '../components/Link';
import PageTitle from '../components/PageTitle';
import LoadingScreen from '../components/LoadingScreen';
import styles from './styles/Arquivos.module.css';

function Arquivos() {
  const token = localStorage.getItem('token');

  const [cnpj, setCnpj] = useState('');
  const [notaFiscal, setNotaFiscal] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [dados, setDados] = useState([]);
  const [error, setError] = useState(null);

  function formatDate(dateString) {
    const date = new Date(dateString);

    // Configuração para o fuso horário do Brasil
    const options = {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        timeZone: 'America/Sao_Paulo'
    };

    // Formatar a data usando o fuso horário brasileiro
    return date.toLocaleString('pt-BR', options);
  }

  // Download dos arquivos
  const handleDownload = async (ide_nnf) => {
    setIsLoading(true); // Inicia o loading
    try {
      const response = await axios.post(
        'https://provin.ind.br/api/arquivos/downloads',
        { ide_nnf }, // Envia o número da nota fiscal para o backend
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
          responseType: 'arraybuffer', // Espera um arquivo binário como resposta
        }
      );

      // Cria um link para download do arquivo ZIP retornado
      const blob = new Blob([response.data], { type: 'application/zip' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = `produtos_nf_${ide_nnf}.zip`; // Nome do arquivo ZIP
      link.click();
    } catch (error) {
      console.error('Erro ao baixar o arquivo:', error);
      alert('Erro ao tentar baixar o arquivo');
    } finally {
      setIsLoading(false); // Finaliza o loading
    }
  };

  // Função de envio do formulário
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Valida se o CNPJ foi preenchido
    if (!cnpj) {
      setError('O campo CNPJ é obrigatório');
      return;
    }

    // Limpa a mensagem de erro antes da requisição
    setError(null);

    try {
      const response = await axios.post(
        'https://provin.ind.br/api/arquivos',
        { cnpj, notaFiscal }, // Dados a serem enviados
        {
          headers: {
            Authorization: `Bearer ${token}`, // Token de autenticação
          },
        }
      );

      console.log(response.data);

      // Armazena os dados recebidos no estado
      setDados(response.data);

    } catch (error) {
      console.error('Erro ao buscar dados:', error);
    }
  };


  return (
    <div className={styles.body}>
      <Header />

      <Link redirectTo="/home" />

      <PageTitle src="images/common/nuvem.svg" title="Arquivos" />

      <div className={styles.container}>
        <form onSubmit={handleSubmit}>
          <input type="text" placeholder="CNPJ" value={cnpj} onChange={(e) => setCnpj(e.target.value)}/>
          <input type="text" placeholder="NOTA FISCAL" value={notaFiscal} onChange={(e) => setNotaFiscal(e.target.value)}/>

          <button type="submit">Pesquisar</button>
        </form>

        {/* Exibe mensagem de erro, se houver */}
        {error && <p style={{ color: 'red', marginTop: '20px' }}>{error}</p>}

        {/* Exibe a tabela com os dados recebidos */}
        {dados.length > 0 && (
          <table>
            <thead>
              <tr>
                <th>NOTA FISCAL</th>
                <th>DATA DE EMISSÃO</th>
                <th>DOWNLOAD</th>
              </tr>
            </thead>

            <tbody>
              {dados.map((nf, index) => (
                <tr key={index}>
                  <td>{nf.ide_nnf}</td>
                  <td>{formatDate(nf.ide_dhemi)}</td>
                  <td><button onClick={() => handleDownload(nf.ide_nnf)}><i className="fa-solid fa-download" style={{ color: "#74C0FC" }}></i></button><p>(Aprox.: <span>{Math.ceil(nf.count_ide_nnf / 60)} min</span>)</p></td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {isLoading && <LoadingScreen />} {/* Exibe a tela de loading */}
    </div>
  );
}

export default Arquivos;